/**
 * NavigationTabs class
 */
export default class NavigationTabs {
    constructor() {
        /**
         *
         * @type {{activeClass: string, tabs: string, tabContent: string}}
         */
        this.defaults = {
            //elements
            tabs: ".js-nav-tab",
            tabContents: ".js-nav-tab-content",

            //CSS state classes
            activeClass: "is-active",
        };

        // Elements
        /**
         * Tab elements
         * @type {NodeListOf<Element>}
         */
        this.tabs = document.querySelectorAll(this.defaults.tabs);
    }

    //region methods

    init() {
        console.log("Navigation init()");

        if (this.tabs.length > 0) {
            this.tabContents = document.querySelectorAll(this.defaults.tabContents);

            this.tabController();
        }
    }

    tabController() {
        this.tabs.forEach((tab) => {
            tab.addEventListener("click", (ev) => {
                ev.preventDefault();

                this.tabs.forEach((tempTab, index) => {
                    if (tempTab === tab) {
                        tempTab.classList.add(this.defaults.activeClass);

                        if (this.tabContents[index] != null) {
                            this.tabContents[index].classList.add(this.defaults.activeClass);
                        }
                    } else {
                        tempTab.classList.remove(this.defaults.activeClass);

                        if (this.tabContents[index] != null) {
                            this.tabContents[index].classList.remove(this.defaults.activeClass);
                        }
                    }
                });
            });
        });
    }

    //endregion
}
